import { createAction } from "redux-starter-kit";

import {
  SAVE_FREEZEEXEMPT_FAILURE,
  SAVE_FREEZEEXEMPT_REQUEST,
  SAVE_FREEZEEXEMPT_SUCCESS
} from "../types";
import fetchFactoringProfile from "./fetchFactoringProfile";
import fetchFreezeEvents from "./fetchFreezeEvents";

const saveFreezeExemptContractTypes = (factoringId, contractTypes) => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(createAction(SAVE_FREEZEEXEMPT_REQUEST)());
    const response = await api.factoring.saveFreezeExemptContractTypes(
      factoringId,
      contractTypes
    );
    dispatch(
      createAction(SAVE_FREEZEEXEMPT_SUCCESS)({
        factoringId,
        contractTypes: response.map(row => row.contract_type)
      })
    );
    // Refetch the factoring profile so the denormalized factor client used
    // by getFreezeExemptContractTypes picks up the new list — the FR-page
    // gates (Save Updates, +New Line Item, Line Item Builder) read from
    // that selector, not from this module's local slice. Also refetch the
    // events list so the new EXEMPT_TYPE_ADDED/REMOVED rows appear in the
    // audit trail without remounting the panel. Fire-and-forget — the
    // form's save flow doesn't wait on either refetch.
    dispatch(fetchFactoringProfile(factoringId));
    dispatch(fetchFreezeEvents(factoringId));
    return response;
  } catch (err) {
    dispatch(createAction(SAVE_FREEZEEXEMPT_FAILURE)(err));
    throw err;
  }
};

export default saveFreezeExemptContractTypes;
